var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c("span", { staticClass: "w-lbl", attrs: { for: _vm.id } }, [
      _vm._v(_vm._s(_vm.$t(_vm.lbl)) + " "),
      _vm.required ? _c("i", [_vm._v("*")]) : _vm._e(),
    ]),
    _vm._v(" "),
    (!!_vm.type ? _vm.type : "text") === "checkbox"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentValue,
              expression: "currentValue",
            },
          ],
          ref: _vm.id,
          staticClass: "form-control",
          class: { "has-error": _vm.error },
          attrs: {
            "data-test": _vm.id,
            placeholder: _vm.placeholder,
            title: _vm.title,
            required: !!_vm.required,
            autofocus: !!_vm.autofocus,
            disabled: _vm.disabled,
            maxlength: _vm.maxLength || 100,
            type: "checkbox",
          },
          domProps: {
            checked: Array.isArray(_vm.currentValue)
              ? _vm._i(_vm.currentValue, null) > -1
              : _vm.currentValue,
          },
          on: {
            input: _vm.onChange,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return (() => {
                return false
              }).apply(null, arguments)
            },
            change: function ($event) {
              var $$a = _vm.currentValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.currentValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.currentValue = $$c
              }
            },
          },
        })
      : (!!_vm.type ? _vm.type : "text") === "radio"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentValue,
              expression: "currentValue",
            },
          ],
          ref: _vm.id,
          staticClass: "form-control",
          class: { "has-error": _vm.error },
          attrs: {
            "data-test": _vm.id,
            placeholder: _vm.placeholder,
            title: _vm.title,
            required: !!_vm.required,
            autofocus: !!_vm.autofocus,
            disabled: _vm.disabled,
            maxlength: _vm.maxLength || 100,
            type: "radio",
          },
          domProps: { checked: _vm._q(_vm.currentValue, null) },
          on: {
            input: _vm.onChange,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return (() => {
                return false
              }).apply(null, arguments)
            },
            change: function ($event) {
              _vm.currentValue = null
            },
          },
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentValue,
              expression: "currentValue",
            },
          ],
          ref: _vm.id,
          staticClass: "form-control",
          class: { "has-error": _vm.error },
          attrs: {
            "data-test": _vm.id,
            placeholder: _vm.placeholder,
            title: _vm.title,
            required: !!_vm.required,
            autofocus: !!_vm.autofocus,
            disabled: _vm.disabled,
            maxlength: _vm.maxLength || 100,
            type: !!_vm.type ? _vm.type : "text",
          },
          domProps: { value: _vm.currentValue },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.currentValue = $event.target.value
              },
              _vm.onChange,
            ],
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return (() => {
                return false
              }).apply(null, arguments)
            },
          },
        }),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "text-danger" }, [
          _c("i", { staticClass: "fas fa-exclamation-triangle" }),
          _vm._v("\n    " + _vm._s(_vm.$t(_vm.lbl_error)) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }